import {
  resolveFindingCvssVersionRecord,
  type FindingCvssVersionKey,
} from '@terra/shared-cvss';
import type { EditableFields } from './finding-editable-fields';

export const resolveFindingEditCvssBaseline = ({
  editableFields,
  originalFields,
  cvssVersion,
  version,
}: {
  editableFields: EditableFields;
  originalFields: EditableFields | null;
  cvssVersion: string | null | undefined;
  version: FindingCvssVersionKey;
}): {
  next: EditableFields['cvss'];
  original: EditableFields['cvss'];
} => ({
  next:
    resolveFindingCvssVersionRecord({
      finding: {
        cvss: editableFields.cvss,
        cvss40: editableFields.cvss40,
        cvss31: editableFields.cvss31,
        cvssVersion,
      },
      version,
    }) ?? null,
  original: originalFields
    ? (resolveFindingCvssVersionRecord({
        finding: {
          cvss: originalFields.cvss,
          cvss40: originalFields.cvss40,
          cvss31: originalFields.cvss31,
          cvssVersion,
        },
        version,
      }) ?? null)
    : null,
});
